import { motion, useReducedMotion } from "framer-motion";

// Shared easing — unhurried, editorial
export const EASE = [0.16, 1, 0.3, 1];

// Fade + rise reveal that triggers on scroll into view
export const Reveal = ({
  children,
  delay = 0,
  y = 28,
  className = "",
  as = "div",
  once = true,
  ...rest
}) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Stagger container + child for grouped reveals
export const StaggerGroup = ({ children, className = "", delay = 0, ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: reduce ? 0 : 0.12, delayChildren: delay } },
      }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

// staggerChild is a fixed y:26 entrance — use getStaggerChild(reduce) instead so
// consumers can honor prefers-reduced-motion the same way Reveal does.
export const getStaggerChild = (reduce = false) => ({
  hidden: { opacity: 0, y: reduce ? 0 : 26 },
  show: { opacity: 1, y: 0, transition: { duration: reduce ? 0.3 : 0.8, ease: EASE } },
});
